// IE10 / 11 polyfill for FileReader.readAsBinaryString
// @help https://stackoverflow.com/a/35170914/870729
import { getLogger } from './logger';

if (FileReader.prototype.readAsBinaryString === undefined) {
  FileReader.prototype.readAsBinaryString = function readAsBinaryString(
    fileData,
  ) {
    let binary = '';
    const pt = this;
    const reader = new FileReader();
    reader.onload = function onload() {
      const bytes = new Uint8Array(reader.result);
      const length = bytes.byteLength;
      for (let i = 0; i < length; i += 1) {
        binary += String.fromCharCode(bytes[i]);
      }
      // pt.result  - readonly so assign content to another property
      pt.content = binary;
      pt.onload(); // thanks to @Denis comment
    };
    reader.readAsArrayBuffer(fileData);
  };
}

export const logger = getLogger('FileReader');

let encodedUpload = '';
export const getEncodedUpload = () => encodedUpload;

export const getFileReader = () => {
  const reader = new FileReader();
  reader.onerror = function onerror(error) {
    logger.error('error trying to read and encode upload selection: ', error);
    encodedUpload = '';
  };

  reader.onload = function onload() {
    // to support the polyfill solution for IE
    const result = reader.result || reader.content;
    encodedUpload = btoa(result);
    reader.onencoded();
  };

  reader.onencoded = () => logger.debug('encoded');

  return reader;
};
